import React, { useMemo } from 'react';
import { TabsWrapper } from 'c-components';
import type { TabWrapperSettings } from 'c-types';
import { useEntityPage } from 'c-hooks';
import ConversionMeasurementSpendTab from './ConversionMeasurementSpendTab';
import ConversionMeasurementExposureTab from './ConversionMeasurementExposureTab';
import ConversionMeasurementDatasetPanel from './ConversionMeasurementDatasetPanel';
import conversionIndexRaw from './Conversion_Index (1).csv?raw';
import combinedExposuresRaw from './combined_exposures.csv?raw';
import combinedConversionsRaw from './combined_conversions.csv?raw';

const FOOTFALL_CAMPAIGN_ID = 13191;

const ConversionMeasurementWrapper: React.FC = () => {
    const { id } = useEntityPage();

    const tabs = useMemo<TabWrapperSettings['tabs']>(
        () => [
            {
                title: 'Spend',
                urlName: 'spend',
                content: <ConversionMeasurementSpendTab />,
            },
            {
                title: 'Exposure',
                urlName: 'exposure',
                content: <ConversionMeasurementExposureTab />,
            },
            {
                title: 'Views',
                urlName: 'views',
                content: (
                    <ConversionMeasurementDatasetPanel
                        rawCsv={conversionIndexRaw}
                        dataset="conversions"
                        lockedEventName="View"
                    />
                ),
            },
            {
                title: 'Initiate Checkout',
                urlName: 'initiate_checkout',
                content: (
                    <ConversionMeasurementDatasetPanel
                        rawCsv={conversionIndexRaw}
                        dataset="conversions"
                        lockedEventName="INITIATE_CHECKOUT"
                    />
                ),
            },
            {
                title: 'Purchase',
                urlName: 'purchase',
                content: (
                    <ConversionMeasurementDatasetPanel
                        rawCsv={conversionIndexRaw}
                        dataset="conversions"
                        lockedEventName="PURCHASE"
                    />
                ),
            },
        ],
        [],
    );

    const footfallTabs = useMemo<TabWrapperSettings['tabs']>(
        () => [
            {
                title: 'Exposures',
                urlName: 'exposures',
                content: (
                    <ConversionMeasurementDatasetPanel
                        rawCsv={combinedExposuresRaw}
                        dataset="exposure"
                        footfall
                    />
                ),
            },
            {
                title: 'Conversions',
                urlName: 'conversions',
                content: (
                    <ConversionMeasurementDatasetPanel
                        rawCsv={combinedConversionsRaw}
                        dataset="conversions"
                        lockedEventName="footfall"
                        rateInTooltipOnly
                        footfall
                    />
                ),
            },
        ],
        [],
    );

    if (Number(id) === FOOTFALL_CAMPAIGN_ID) {
        return <TabsWrapper tabs={footfallTabs} type="secondary" urlStatePath="cmFootfallTab" />;
    }

    return <TabsWrapper tabs={tabs} type="secondary" urlStatePath="cmTab" />;
};

export default ConversionMeasurementWrapper;
